module.exports = "/_next/static/images/944ed09de254015b22ed20c7a39cceeb-coin.svg";